import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SwitchButton from '../common/SwitchButton';
import HeaderBack from './components/HeaderBack';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import styles from '../common/customStylesRadioButton';
import axios from 'components/AppRequest';
import { setUserLogout } from 'components/actions/authActions';
import withRouter from 'components/components/common/withRouter';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import { setTranslation } from 'components/actions'
import TransHelper from 'components/common/translations/TransHelper';
import {
  createSuccessNotification,
  createErrorNotification,
} from 'components/actions/serviceActions';
import originAxios from 'axios';

class Settings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedValue: props.locale,
    };
  }

  handleChange = event => {
    var value = event.target.value;
    TransHelper.translateCurrentUrl(
      value,
      this.props.locale,
      this.props.history,
      this.props.location
    );
    this.setState({ selectedValue: value });
    this.props.setTranslation(value);
    LocalStorageHelper.setLocale(value);
    var params = { data: { lang: value } };
    originAxios.post('/save-locale', { locale: value });
    axios.post('/pwa/customer/update-language', params)
      .then(response => {
        this.props.createSuccessNotification({
          message: this.transNotify('success')
        });
      })
      .catch(err => {
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: mergeErrors(err.response.data.errors),
        });
      })
  };

  trans = (key, pref = "content.account.settings") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.settings');
  }

  render() {
    return (
      <div className="content" style={{ padding: '0' }}>
        <HeaderBack locale={this.props.locale} />
        <div className="content__desc">
          <h1>{this.trans('title')}</h1>
          <ul className="list-border" style={{ borderTop: '1px solid #e0e0e0' }}>
            <li className="list-border__item">
              <span className="notification-wrap">
                <FontAwesomeIcon
                  icon={['fas', 'bell']}
                />
                {this.trans('notifications')}
                <SwitchButton />
              </span>
            </li>

            <li className="list-border__item">
              <span>
                <FontAwesomeIcon
                  icon={['fas', 'globe']}
                />{this.trans('language')}
              </span>
            </li>

            <li className="list-border__item">
              <label htmlFor="lang-norwegian">
                {this.trans('langs.no')}
                <Radio
                  value="no"
                  checked={this.state.selectedValue === 'no'}
                  onChange={this.handleChange}
                  classes={{
                    root: this.props.classes.root,
                    checked: this.props.classes.checked,
                  }}
                  className="radio-button"
                  name="language"
                />
              </label>
            </li>

            <li className="list-border__item">
              <label htmlFor="lang-english">
                {this.trans('langs.en')}
                <Radio
                  value="en"
                  checked={this.state.selectedValue === 'en'}
                  onChange={this.handleChange}
                  classes={{
                    root: this.props.classes.root,
                    checked: this.props.classes.checked,
                  }}
                  className="radio-button"
                  name="language"
                />
              </label>
            </li>

            <li className="list-border__item">
              <label htmlFor="lang-polish">
                {this.trans('langs.pl')}
                <Radio
                  value="pl"
                  checked={this.state.selectedValue === 'pl'}
                  onChange={this.handleChange}
                  classes={{
                    root: this.props.classes.root,
                    checked: this.props.classes.checked,
                  }}
                  className="radio-button"
                  name="language"
                />
              </label>
            </li>

            {/* <li className="list-border__item">
              <label htmlFor="lang-russian">
                {this.trans('langs.ru')}
                <Radio
                  value="ru"
                  checked={this.state.selectedValue === 'ru'}
                  onChange={this.handleChange}
                  classes={{
                    root: this.props.classes.root,
                    checked: this.props.classes.checked,
                  }}
                  className="radio-button"
                  name="language"
                />
              </label>
            </li> */}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setTranslation, setUserLogout, createSuccessNotification, createErrorNotification }
  )(withStyles(styles)(Settings)));
